import React from 'react';
import TopBanner from '../MainContents/TopBanner'; 
import Decision from './PassingDecision'; 
import Area from './AreaDecision'; 
import SuccessNewsletter from './SuccessNewsletter';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';

const TableScope = styled.table`
  width: 90%;
  margin: auto;
  table-layout: fixed;
  word-wrap: break-word;
  overflow-x: auto;
  display: table;
  @media ${device.laptop}{
     display: block !important;
  }
`;

const Success = () =>  {
    const style = {color: 'red' }
    return (
        <div>
        <ScrollToTopOnMount />
            {/* 合格実績*/}
            <div>
                <TopBanner  title="2025年度 合格速報" 
                            text1="" 
                            text2="※判明分から随時掲載しているため、確定人数であるとは限りません。(最終更新: 2025/2/19)" />

                <SuccessNewsletter />

                <TopBanner  title="はりまやYT教室 合格実績(2016年～2025年)" 
                            text1="※はりまやYT教室在籍生の合格実績であり、講座生・四谷テスト生などは、一切含んでいません。" 
                            text2="※赤字の合格者数は全員合格となっています。" />
                            {/* text2="※赤字の合格者数は全員合格となっています。また、卒業生全員が、県内外の難関中学に合格し進学しています。" /> */}
                <TableScope id="achievement" className="table table-bordered text-center">
                      <tbody>
                          <tr>
                              <td colspan="3" className="">主要合格中学校</td>
                              <td>2025年度</td>
                              <td>2024年度</td>
                              <td>2023年度</td>
                              <td>2022年度</td>
                              <td>2021年度</td>
                              <td>2020年度</td>
                              <td>2019年度</td>
                              <td>2018年度</td>
                              <td>2017年度</td>
                              <td>2016年度</td>
                          </tr>
                        <tr>
                          <td colspan="3">卒業生数</td>
                          <td>13名</td>
                          <td>5名</td>
                          <td>10名</td>
                          <td>6名</td>
                          <td>6名</td>
                          <td>11名</td>
                          <td>10名</td>
                          <td>10名</td>
                          <td>11名</td>
                          <td>11名</td>
                        </tr>
                        <tr>
                          <td rowspan="2">県内</td>
                          <td colspan="2">土佐中学校</td>
                          <td {...{style}} >7名</td>
                          <td {...{style}} >5名</td>
                          <td>8名</td>
                          <td {...{style}} >4名</td>
                          <td {...{style}} >4名</td>
                          <td {...{style}} >8名</td>
                          <td {...{style}} >8名</td>
                          <td {...{style}} >7名</td>
                          <td {...{style}} >7名</td>
                          <td {...{style}} >9名</td>
                        </tr>
                        <tr>
                          <td colspan="2">土佐塾中<br/>(内特待)</td>
                          <td{...{style}} >3名<br/>(2名)</td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名<br/>(1名)</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名<br/>(1名)</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td rowspan="14">県外</td>
                          <td colspan="2">灘中学校</td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="2">東大寺学園</td>
                          <td></td>
                          <td>1名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td>1名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="2">西大和学園</td>
                          <td></td>
                          <td></td>
                          <td>2名</td>
                          <td></td>
                          <td {...{style}} >2名</td>
                          <td>1名</td>
                          <td>1名</td>
                          <td {...{style}} >1名</td>
                          <td {...{style}} >1名</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="2">栄光学園</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="2">浦和明の星女子中学</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="2">鴎友学園女子中学</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="2">神戸女学院</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名</td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名</td>
                        </tr>
                        <tr>
                          <td colspan="2">ラ・サール中学</td>
                          <td{...{style}} >5名</td>
                          <td></td>
                          <td {...{style}} >3名</td>
                          <td></td>
                          <td></td>
                          <td>2名</td>
                          <td>1名</td>
                          <td {...{style}} >4名</td>
                          <td>4名</td>
                          <td>2名</td>
                        </tr>
                        <tr>
                          <td colspan="2">海城中学</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >2名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="2">四天王寺中学</td>
                          <td {...{style}} >1名</td>
                          <td {...{style}} >1名</td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="2">愛光中学</td>
                          <td >7名</td>
                          <td {...{style}} >3名</td>
                          <td {...{style}} >7名</td>
                          <td {...{style}}>5名</td>
                          <td>2名</td>
                          <td>4名</td>
                          <td>8名</td>
                          <td {...{style}} >10名</td>
                          <td>9名</td>
                          <td {...{style}} >11名</td>
                        </tr>
                        <tr>
                          <td colspan="2">同志社中</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td {...{style}}>1名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="2">巣鴨</td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td colspan="2">岡山(東・医)</td>
                          <td {...{style}} >2名</td>
                          <td {...{style}} >1名</td>
                          <td {...{style}} >2名</td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td {...{style}} >1名</td>
                          <td></td>
                          <td {...{style}} >2名</td>
                        </tr>
                      </tbody>
                  </TableScope>

                <Area />
                {/* 合不合判定テスト　難関国私立中学　合格判定(可能性 80%)　偏差値 */}
                {/* 偏差値 */}
                <Decision />
            </div>
        </div>
    );
  };


export default Success;
